import { AnimationBaseController, IAnimationControllerConfiguration, Inject, SoundType } from "@denishussar/html5-game-engine";
import { SoundConstants } from "../../../Constants/SoundConstants";
import { EngineLogic } from "../../../Logic/MiniGames/EngineLogic";
import { EnginePowerUpModel } from "../../../Models/MiniGames/PowerEnigineUpModel";

export enum engineButtons{
    none = 0,
    reactor1,
    reactor2,
    contur1,
    contur2,
    powerUp,
    dialog,
    //sliders
    turbine,
    generator
}

export enum engineButtonState {
    released,
    pressed,
    active
}

export interface IEngineGameButtonControllerOptions {
    btn:number;
    model: EnginePowerUpModel;
    onClick: ()=> void;
}

export class EngineButtonController extends AnimationBaseController {
    public $model: EnginePowerUpModel;
    private btn:number;
    private _width: number;
    private _height:number;
    private onClick;
    public constructor(
        @Inject private _options: IEngineGameButtonControllerOptions,
    ){
        super('EngineButtonController');
        this.btn = _options.btn;
        this.onClick = _options.onClick;
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            sounds: [
                {
                    id: SoundConstants.ENGINE_BUTTON,
                    type:SoundType.SFX
                },
                {
                    id: SoundConstants.ENGINE_TUMBLER,
                    type:SoundType.SFX
                },
            ],
            onPointerDown: ()=>{
                if (this.$model.btnStates[this.btn] < 1){
                    this.playState(engineButtonState.pressed);
                    if (!this.$model.showDialog)
                    if (this.btn < engineButtons.turbine)
                        this.soundManager.playSound(SoundConstants.ENGINE_BUTTON);
                    else
                        this.soundManager.playSound(SoundConstants.ENGINE_TUMBLER);
                }
                this.onClick();
            },
            onPointerUp: ()=>{
                
                this.playState(this.$model.btnStates[this.btn]);
            },
            modelWatch: {
                btnStates: (btnStates: number[])=>{
                    this.playState(btnStates[this.btn]);
                },
            }
        }
        
    }

    private playState(state: number):void{
        if (this.btn < engineButtons.turbine)
            switch (state){
                case engineButtonState.released:
                    this.gotoAndStop('idle');
                    break;
                case engineButtonState.pressed:
                    this.gotoAndStop('press');
                    break;
                case engineButtonState.active:
                    this.gotoAndStop('active');
                    break;
            }
        else{
            switch (state){
                case engineButtonState.released:
                    this.gotoAndStop('slider_off');
                    break;
                case engineButtonState.pressed:
                    this.gotoAndPlay('slider_off');
                    break;
            }
        }
    }

    onInitialize(): void {
        
    }

}